<template>
  <div class="ap-message" ref="msg" :class="[activeClass, {'is-show': isShow}]">
    <span class="text text-truncate">{{msg}}</span>
    <span class="clo float-right" @click="close" aria-hidden="true">&times;</span>
  </div>
</template>

<script>
export default {
  data() {
    return {
      msg: "",
      lazy: 0,
      type: "",
      isShow: false
    };
  },
  computed: {
    activeClass() {
      if (this.type == "success") return "ap-message-success";
      if (this.type == "warning") return "ap-message-warning";
      if (this.type == "danger") return "ap-message-danger";
    }
  },
  created() {
    let vm = this;
    window.$msg = {
      msg,
      warning,
      error
    };
    function msg(txt, delay = 3) {
      vm.show(txt, delay, "success");
    }

    function warning(txt, delay = 4) {
      vm.show(txt, delay, "warning");
    }

    function error(txt, delay = 5) {
      vm.show(txt, delay, "danger");
    }
  },
  methods: {
    lazyClose() {
      $msg.timeOutId = setTimeout(() => {
        this.close();
        $msg.timeOutId = null;
      }, this.lazy * 1000);
    },
    close() {
      this.isShow = false;
    },
    show(txt, lazy, type) {
      if (!$msg.timeOutId) return this.init(txt, lazy, type);
      clearTimeout($msg.timeOutId);
      $msg.timeOutId = null;
      this.close();
      setTimeout(() => {
        this.init(txt, lazy, type);
      }, 200);
    },
    init(txt, lazy, type) {
      this.msg = txt;
      this.lazy = lazy;
      this.type = type;
      this.isShow = true;
      this.lazyClose();
    }
  }
};
</script>

<style lang="less" scoped>
.ap-message-success {
  background: #34cc99;
}
.ap-message-warning {
  background: #ffbf48;
}
.ap-message-danger {
  background: red;
}
.is-show {
  top: 11px !important;
}
.ap-message {
  position: fixed;
  z-index: 10000;
  top: -40px;
  left: 50%;
  transform: translateX(-50%);
  padding: 5px 10px;
  min-width: 300px;
  border-radius: 5px;
  transition: all 0.2s;
  .text {
    color: #fff;
    margin-right: 10px;
    vertical-align: middle;
  }
  .clo {
    vertical-align: middle;
    font-size: 22px;
    font-weight: 700;
    line-height: 22px;
    color: #fff;
    opacity: 0.7;
    &:hover {
      opacity: 1;
      cursor: pointer;
    }
  }
}
</style>